import FollowToWatchReels from './FollowToWatchReels';
import PrevOrders from './PreviousOrders';
import OffersForYou from './OffersForYou';
import Restaurantnearyou from './Restaurantnearyou';
import './Home.css';
import { CONSTANT, SEO } from '../../../Utils/Constant';
import { Helmet } from 'react-helmet';
function Home() {
    return (
        <div >
            <Helmet>
                <title>{SEO.HOME_PAGE.TITLE}</title>
                <meta name="description" content={SEO.HOME_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.HOME_PAGE.KEYWORDS} />              
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={SEO.HOME_PAGE.CANONICAL} />
            
                <meta property="og:title" content={SEO.HOME_PAGE.OG.TITLE} />
                <meta property="og:description" content={SEO.HOME_PAGE.OG.DESCRIPTION} />
                <meta property="og:type" content={SEO.HOME_PAGE.OG.TYPE} />
                <meta property="og:url" content={SEO.HOME_PAGE.OG.URL} />
                <meta property="og:site_name" content={SEO.HOME_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
            
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.HOME_PAGE.TWITTER.TITLE} />
                <meta name="twitter:description" content={SEO.HOME_PAGE.TWITTER.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />
            
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'WebPage',
                        name: `${CONSTANT.OMYFOOD} - Discover Food, Watch Reels, Get Offers & Order Nearby`,
                        url: 'https://omyfood.io',
                        description: 'Explore trending food reels, revisit past orders, unlock personalized offers, and find top restaurants near you — all on OMF, your food discovery and delivery hub.',
                        publisher: {
                            '@type': 'Organization',
                            'name': 'OMF',
                            'url':  `${CONSTANT.OMYFOOD_WEB_LINK}`,
                            'logo': {
                                '@type': 'ImageObject',
                                'url': 'https://omyfood.io/OMF_logo_bg.png', 
                                'width': 600,
                                'height': 60
                            }
                        }
                    })
                    }
                </script>

            
            </Helmet>
            <FollowToWatchReels></FollowToWatchReels>
            <PrevOrders></PrevOrders>
            <OffersForYou></OffersForYou>
            <Restaurantnearyou></Restaurantnearyou>
        </div>
    );
}
export default Home;
